<template>
    <div class="administrar-planta-eventos container-fluid mt-4">
      <h2>Plantas de este Evento</h2>
  
      <!-- Filtros -->
      <div class="filters my-3 d-flex flex-wrap gap-2 align-items-center">
        <input
          type="text"
          v-model="filterPlanta"
          class="form-control form-control-sm"
          placeholder="Filtrar por planta..."
          style="max-width: 200px;"
        />
        <input
          type="date"
          v-model="filterFechaInicio"
          class="form-control form-control-sm"
          style="max-width: 180px;"
        />
        <input
          type="date"
          v-model="filterFechaFin"
          class="form-control form-control-sm"
          style="max-width: 180px;"
        />
        <button class="btn btn-secondary btn-sm" @click="clearFilters">Limpiar Filtros</button>
      </div>
  
      <!-- Listado de planta_eventos -->
      <div v-if="loading" class="text-center my-3">Cargando eventos...</div>
      <div v-else>
        <table class="table table-striped table-responsive">
          <thead class="table-light">
            <tr>
              <th>ID</th>
              <th>Planta</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
              <th>Observaciones</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="evento in paginatedPlantaEventos" :key="evento.id">
              <td>{{ evento.id }}</td>
              <td>
                {{ evento.planta?.nombre || 'N/D' }}
                <br>
                <small class="text-muted">Lote: {{ evento.planta?.lote?.nombre || 'N/D' }}</small>
              </td>
             
              <td>{{ formatDate(evento.fecha_inicio) }}</td>
              <td>{{ formatDate(evento.fecha_fin) || 'N/A' }}</td>
              <td>{{ evento.observaciones || '' }}</td>
              <td>
                <button class="btn btn-sm btn-outline-primary me-1" @click="editEvento(evento)">Editar</button>
                <button class="btn btn-sm btn-outline-danger" @click="deleteEvento(evento.id)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="!filteredPlantaEventos.length" class="text-center text-muted">
          No se encontraron registros.
        </div>
      </div>
  
      <!-- Paginación -->
      <nav v-if="totalPages > 1" class="mt-3">
        <ul class="pagination pagination-sm justify-content-center">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a class="page-link" href="#" @click.prevent="currentPage--">Anterior</a>
          </li>
          <li
            class="page-item"
            v-for="page in totalPages"
            :key="page"
            :class="{ active: currentPage === page }"
          >
            <a class="page-link" href="#" @click.prevent="currentPage = page">{{ page }}</a>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <a class="page-link" href="#" @click.prevent="currentPage++">Siguiente</a>
          </li>
        </ul>
      </nav>
  
      <!-- Formulario para crear/editar planta_evento -->
      <div v-if="showForm" class="card shadow-sm p-3 my-3">
        <h5>{{ formMode === 'edit' ? 'Editar' : 'Crear' }} Evento de Planta</h5>
        <form @submit.prevent="submitForm">
          <div class="mb-2">
            <label for="fecha_inicio" class="form-label mb-0">Fecha Inicio:</label>
            <input type="date" v-model="form.fecha_inicio" class="form-control form-control-sm" id="fecha_inicio" required />
          </div>
          <div class="mb-2">
            <label for="fecha_fin" class="form-label mb-0">Fecha Fin:</label>
            <input type="date" v-model="form.fecha_fin" class="form-control form-control-sm" id="fecha_fin" />
          </div>
          <div class="mb-2">
            <label for="observaciones" class="form-label mb-0">Observaciones:</label>
            <textarea v-model="form.observaciones" class="form-control form-control-sm" id="observaciones" rows="2"></textarea>
          </div>
          <div class="d-flex gap-2">
            <button type="submit" class="btn btn-success btn-sm">
              {{ formMode === 'edit' ? 'Actualizar' : 'Crear' }}
            </button>
            <button type="button" class="btn btn-secondary btn-sm" @click="cancelForm">Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  import { mapGetters } from 'vuex';

  
  export default {
    name: 'listarPlantaEvento',

    props: {
      proyecto_id: {
        type: Number,
        required: true,
      },
      proyecto_evento_id: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        plantaEventos: [],
        loading: false,
        filterPlanta: '',
        filterSala: '',
        filterFechaInicio: '',
        filterFechaFin: '',
        mostrarSoloActivas: true, // por defecto, solo mostrar eventos sin fecha_fin
        currentPage: 1,
        pageSize: 10,
        showForm: false,
        formMode: 'create', // o 'edit'
        form: {
          id: null,
          fecha_inicio: '',
          fecha_fin: '',
          observaciones: '',
        },
        club_id:this.$store.getters.getClubActual.id
      };
    },
    computed: {
      ...mapGetters(['getClubActual']),
      filteredPlantaEventos() {
        let list = this.plantaEventos;
  
        // Filtrar por planta (nombre)
        if (this.filterPlanta) {
          list = list.filter(item =>
            item.planta?.nombre.toLowerCase().includes(this.filterPlanta.toLowerCase())
          );
        }
  
        // Filtrar por sala (nombre)
        if (this.filterSala) {
          list = list.filter(item =>
            item.proyecto_evento?.proyecto?.nombre.toLowerCase().includes(this.filterSala.toLowerCase())
          );
        }
  
        // Filtrar por fecha de inicio (si se proporciona)
        if (this.filterFechaInicio) {
          list = list.filter(item =>
            new Date(item.fecha_inicio).toLocaleDateString() === new Date(this.filterFechaInicio).toLocaleDateString()
          );
        }
        // Filtrar por fecha de fin: si mostrarSoloActivas es true, se excluyen los que tengan fecha_fin
        if (this.mostrarSoloActivas) {
          list = list.filter(item => !item.fecha_fin);
        }
        if (this.filterFechaFin) {
          list = list.filter(item =>
            new Date(item.fecha_fin).toLocaleDateString() === new Date(this.filterFechaFin).toLocaleDateString()
          );
        }
        return list;
      },
      paginatedPlantaEventos() {
        const start = (this.currentPage - 1) * this.pageSize;
        return this.filteredPlantaEventos.slice(start, start + this.pageSize);
      },
      totalPages() {
        return Math.ceil(this.filteredPlantaEventos.length / this.pageSize);
      },
    },
    mounted() {
      this.fetchPlantaEventos();
    },
    methods: {
      async fetchPlantaEventos() {
        this.loading = true;
        try {
     
        
          const res = await axios.get('/api/planta_eventos', {
            params: {club_id:this.club_id, proyecto_id:this.proyecto_id, proyecto_evento_id:this.proyecto_evento_id },
          });
          this.plantaEventos = res.data;
        } catch (error) {
          console.error("Error al obtener planta eventos:", error);
        } finally {
          this.loading = false;
        }
      },
      formatDate(dateStr) {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString();
      },
      // Muestra el formulario para crear un nuevo registro
      showCreateForm() {
        this.formMode = 'create';
        this.form = {
          id: null,
          fecha_inicio: new Date().toISOString().split('T')[0],
          fecha_fin: '',
          observaciones: '',
        };
        this.showForm = true;
      },
      // Muestra el formulario con datos para editar
      editEvento(evento) {
        this.formMode = 'edit';
        this.form = {
          id: evento.id,
          fecha_inicio: evento.fecha_inicio ? new Date(evento.fecha_inicio).toISOString().split('T')[0] : '',
          fecha_fin: evento.fecha_fin ? new Date(evento.fecha_fin).toISOString().split('T')[0] : '',
          observaciones: evento.observaciones || '',
        };
        this.showForm = true;
      },
      async submitForm() {
        try {
          if (this.formMode === 'create') {
            // Crear un nuevo registro
            await axios.post('/api/planta_eventos', this.form,{params:{club_id:this.club_id}});
            alert("Evento creado correctamente.");
          } else {
            // Actualizar registro existente
            await axios.put(`/api/planta_eventos/${this.form.id}`, this.form,{params:{club_id:this.club_id}});
            alert("Evento actualizado correctamente.");
          }
          this.showForm = false;
          this.fetchPlantaEventos();
        } catch (error) {
          console.error("Error al enviar formulario:", error);
          alert("Error al procesar la solicitud.");
        }
      },
      async deleteEvento(id) {
        if (!confirm("¿Está seguro de eliminar este evento?")) return;
        try {
          await axios.delete(`/api/planta_eventos/${id}`,{params:{club_id:this.club_id}});
          alert("Evento eliminado correctamente.");
          this.fetchPlantaEventos();
        } catch (error) {
          console.error("Error al eliminar el evento:", error);
          alert("Error al eliminar el evento.");
        }
      },
      cancelForm() {
        this.showForm = false;
      },
    },
  };
  </script>
  
  <style scoped>
  .listar-sala-planta {
    padding: 15px;
    background-color: #f7f8fa;
  }
  .filters input,
  .filters select {
    width: 100%;
  }
  .table {
    margin-top: 15px;
  }
  @media (max-width: 576px) {
    .btn {
      font-size: 0.75rem;
      padding: 4px 8px;
    }
  }
  </style>
  